import { Breadcrumbs } from "components/breadcrumbs";
import { useOne, useParse } from "@refinedev/core";
import { FullScreenLoading } from "components/fullScreenLoading";
import { ISupportCategoryItem } from "interfaces";
import { EditSupportCategoryForm } from "./components";

export const EditSupportCategory: React.FC = () => {
  const parse = useParse();
  const { params } = parse();

  const {
    data,
    isFetching,
    isPreviousData,
    isLoading,
  } = useOne<ISupportCategoryItem>({
    resource: "cs/support-center/categories",
    id: params?.id,
    meta: {
      resource: "data",
    },
    queryOptions: {
      enabled: !!params?.id,
    } as any,
  });

  const supportCategoryDetailData = data?.data ?? null;

  if (isLoading) {
    return <FullScreenLoading />;
  }

  return (
    <div className="wrapper">
      <Breadcrumbs customPageLabel="Edit Support Center Category" />
      {supportCategoryDetailData ? (
        <EditSupportCategoryForm
          defaultData={supportCategoryDetailData}
          id={params?.id}
        />
      ) : (
        <></>
      )}
      {isFetching && isPreviousData ? <FullScreenLoading /> : <></>}
    </div>
  );
};
